import { KyronClient } from '../components/utils/KyronClient';

export async function createKyronAssignment(classroomId: number, lessonCollectionId: number): Promise<boolean> {
  const client = new KyronClient();
  return await client.getDataWithError<boolean>(
    `/api/v1/teacher_dashboards/create_kyron_assignment?classroom_id=${classroomId}&lesson_id=${lessonCollectionId}`,
  );
}
